import { Button } from "$components/button/button";
import { DialogBody } from "$components/dialog/dialog-body";
import { DialogContainer } from "$components/dialog/dialog-container";
import { DialogFooter } from "$components/dialog/dialog-footer";
import { FormattedMessage } from "react-intl";
import { RegisterDownloadWarning } from "../../_lib/register-download-warning";

export const RegisterDownloadModal = ({
  open,
  onConfirm,
  onCancel,
}: {
  open: boolean;
  onCancel: () => void;
  onConfirm: () => Promise<void>;
}) => (
  <DialogContainer open={open}>
    <DialogBody>
      <RegisterDownloadWarning />
    </DialogBody>
    <DialogFooter>
      <Button color="secondary" onClick={onCancel}>
        <FormattedMessage
          id="register-requests.downloadmodal.cancel"
          defaultMessage="Cancel"
        />
      </Button>
      <Button onClick={onConfirm}>
        <FormattedMessage
          id="register-requests.downloadmodal.download"
          defaultMessage="Download"
        />
      </Button>
    </DialogFooter>
  </DialogContainer>
);
